import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ToolBarGroup } from 'foundations-components/transitional/components/ToolBarGroup';
import { Link } from 'foundations-components/transitional/components/Link';
import { Big } from 'foundations-components/transitional/components/Big';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { BackButton } from 'foundations-components/transitional/components/BackButton';
import { ToolBar } from 'foundations-components/transitional/components/ToolBar';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class EPFullScreenModal extends Component {
  constructor(props) {
    super(props);
    this.renderHeader = this.renderHeader.bind(this);
  }
  renderHeader() {
    const {
      headerButton,
      headerContent,
      onClose
    } = this.props;
    return /*#__PURE__*/_jsx(View, {
      borderBlockEndColor: "border-core-subtle",
      borderBlockEndWidth: "200",
      borderBlockEndStyle: "solid",
      position: "relative",
      boxShadow: "100",
      children: /*#__PURE__*/_jsxs(ToolBar, {
        use: "tabs",
        paddingInline: "600",
        paddingBlock: "400",
        children: [/*#__PURE__*/_jsx(ToolBarGroup, {
          minWidth: "33%",
          children: /*#__PURE__*/_jsx(BackButton, {
            children: /*#__PURE__*/_jsx(Link, {
              "data-test-id": "preview-modal-close",
              onClick: onClose,
              marginInlineStart: "0",
              children: /*#__PURE__*/_jsx(Big, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "epFullScreenModal.back"
                })
              })
            })
          })
        }), /*#__PURE__*/_jsx(ToolBarGroup, {
          children: headerContent
        }), /*#__PURE__*/_jsx(ToolBarGroup, {
          minWidth: "33%",
          children: headerButton
        })]
      })
    });
  }
  render() {
    return /*#__PURE__*/_jsx(Modal, {
      use: "fullscreen",
      children: /*#__PURE__*/_jsxs(View, {
        blockSize: "100%",
        children: [this.renderHeader(), /*#__PURE__*/_jsx(View, {
          blockSize: "calc(100% - 74px)",
          overflowY: "scroll",
          children: this.props.children
        })]
      })
    });
  }
}
EPFullScreenModal.propTypes = {
  headerButton: PropTypes.node,
  headerContent: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node
};
export default EPFullScreenModal;